import { render, staticRenderFns } from "./BloodSugarDistributionChart.vue?vue&type=template&id=13d0523b"
import script from "./BloodSugarDistributionChart.vue?vue&type=script&lang=js"
export * from "./BloodSugarDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports